/** Analytics Portal V1 — error state (Phase 9, plan §12.7). Shows the normalized safe
 * message only: never a stack trace, query, collection name or entitlement internal. */
import React from "react";
import { AlertTriangle, RotateCw } from "lucide-react";
import { Button } from "@/components/ui/button";

export const ErrorState = ({ error, onRetry }) => (
  <div className="flex flex-col items-start gap-3 rounded-xl border border-destructive/30 bg-destructive/5 px-5 py-6"
       data-testid="analytics-error" role="alert" aria-live="polite">
    <span className="flex h-10 w-10 items-center justify-center rounded-full bg-card">
      <AlertTriangle className="h-5 w-5 text-destructive" aria-hidden="true" />
    </span>
    <div>
      <h3 className="text-base font-[620] text-foreground">We couldn&apos;t load analytics</h3>
      <p className="mt-1 text-sm text-muted-foreground" data-testid="analytics-error-message">
        {error?.message || "Something went wrong loading analytics."}
      </p>
      {error?.retryAfter ? (
        <p className="mt-1 text-xs text-muted-foreground">
          Try again in about {error.retryAfter} seconds.
        </p>
      ) : null}
    </div>
    {onRetry && (
      <Button variant="secondary" size="sm" onClick={onRetry} data-testid="analytics-error-retry">
        <RotateCw className="mr-2 h-4 w-4" aria-hidden="true" /> Try again
      </Button>
    )}
  </div>
);
